import { ClassificationLabels } from "../../../models/classification.map";
import { isUnresolvedMedicamentDestination } from "./commandeDraft";
import { findMatchingPatient, samePharmaPatientPayload } from "./commandeDraftMerge";

// Règles qui bloquent ou reportent la sauvegarde d'une commande, et messages d'erreur.

/** Le serveur refuse la sauvegarde car il ne trouve pas de verrou actif pour l'utilisateur. */
export function isLockLostError(error) {
    return error?.response?.status === 409
        && /non verrouillée/i.test(error?.response?.data?.message || "");
}

export function sameUser(left, right) {
    return !!left && !!right && String(left).trim().toLowerCase() === String(right).trim().toLowerCase();
}

export function validatePatients(patients) {
    return patients.flatMap((patient, index) => validatePatient(patient, index));
}

export function hasIncompletePatientIdentity(patients) {
    return (patients || []).some(patient =>
        !patient?.nom?.trim() || !patient?.prenom?.trim()
    );
}

export function patientLabel(patient, index) {
    const name = [patient?.nom, patient?.prenom].filter(Boolean).join(" ").trim();
    return name || `Patient ${index + 1}`;
}

export function validatePatient(patient, index) {
    const label = patientLabel(patient, index);
    const errors = [];
    if (!patient?.nom?.trim()) errors.push(`${label} : nom obligatoire`);
    if (!patient?.prenom?.trim()) errors.push(`${label} : prénom obligatoire`);
    if (patient?.classification && !Object.hasOwn(ClassificationLabels, patient.classification)) {
        errors.push(`${label} : classification inconnue (${patient.classification})`);
    }
    (patient?.produits || []).forEach((produit, produitIndex) => {
        if (isUnresolvedMedicamentDestination(produit?.destination)) {
            errors.push(`${label} : destination obligatoire pour le médicament ${produitIndex + 1}`);
        }
    });
    return errors;
}

export function hasIncompleteMedicamentDestination(patients) {
    return (patients || []).some(patient =>
        (patient?.produits || []).some(produit => isUnresolvedMedicamentDestination(produit?.destination))
    );
}

/**
 * Patients dont un médicament n'a pas de destination ET qui ont été ajoutés ou modifiés depuis le chargement.
 * Un patient déjà enregistré et intact (par exemple arrivé du portail EHPAD sans destination) ne bloque pas
 * la sauvegarde des autres : il est envoyé « inchangé » et reste tel quel.
 */
export function patientsBlockedByDestination(patients, originalPatients) {
    return (patients || []).filter(patient =>
        hasIncompleteMedicamentDestination([patient])
        && !samePharmaPatientPayload(patient, findMatchingPatient(patient, originalPatients || []))
    );
}

export function canDeferPatientSave(draft) {
    return draft?.destination === "RECLAMATION" && hasIncompletePatientIdentity(draft.patients);
}

export function apiErrorMessage(error) {
    return error?.response?.data?.message
        || error?.response?.data?.detail
        || error?.message
        || "Erreur inconnue";
}
